import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const AuthCallback = () => {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const run = async () => {
            const hash = window.location.hash || "";
            const params = new URLSearchParams(hash.replace(/^#/, ""));
            const sessionId = params.get("session_id");
            // Role intent is carried via sessionStorage (set before the OAuth redirect) —
            // query params on the redirect URL break the auth service's state validation.
            const intentRole =
                new URLSearchParams(window.location.search).get("role") ||
                sessionStorage.getItem("cc_intent_role");
            sessionStorage.removeItem("cc_intent_role");
            if (!sessionId) {
                navigate("/login");
                return;
            }
            try {
                await api.post("/auth/session", { session_id: sessionId });
                await refresh();
                navigate(intentRole ? `/role?role=${intentRole}` : "/role", { replace: true });
            } catch (e) {
                navigate("/login");
            }
        };
        run();
    }, [navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-yc-cream" data-testid="auth-callback-loading">
            <div className="font-heading text-lg">Signing you in…</div>
        </div>
    );
};

export default AuthCallback;
